<template>
	<div class="applyInvoiceList">
		<!-- 申请发票弹窗 -->
		<el-dialog :visible="true" width='800px' title='发票抬头选择' @close="close" :close-on-click-modal="false" :close-on-press-escape="false">
			<div class="innerBox">
				<!-- 发票  -->
				<div class="innerContent " :style=" choseRadio == index? 'border: 1px solid #1890FF;':'border:0' " v-for="(item,index) in tableData"
				 :key='index'>
					<div v-if='item.defaultFlag == 1' class="defaltClass">
						<span>默认</span>
					</div>
					<div class="innerContent1">
						<el-radio v-model="choseRadio" :label='index'>

							<span class="nameClass">{{item.receiveName}}</span>
							<span class="nameClass">({{item.receiveMobile}})</span>
							<div class="innerContent3 innerContent2">
								<div class='invoiceTitle' v-for="(value, index) in tableDec1" :key='index'>
									<i :class="value"></i>
									<span class="inner2Index">{{item[index]}}</span>
								</div>
							</div>
							<div class="innerContent3">
								<div class='invoiceTitle' v-for="(value,key) in tableDec" :key='key'>
									<p class="valueDec">{{value}}: </p>
									<p class="tableKeyDec">{{item[key]}}</p>
								</div>
							</div>
						</el-radio>
					</div>

				</div>
			</div>
			<div class="sureSubmit">
        <p v-show="orderRecoderIdArr.length && isBatchOrder" class="tip">
          注：当前共选择
          <span>{{orderRecoderIdArr.length}}</span>
          笔订单批量开票
        </p>
				<span class="submitClass" @click="close">关闭</span>
				<span class="submitClass " :style=" 'margin-left: 10px;'+ (choseRadio ==-1? 'background-color:#c3c0bb':'background-color:#1890FF') "
				 @click="submitBtn">申请开票</span>
			</div>
		</el-dialog>
	</div>
</template>

<script>
	import evn from '../../../evn.js'
	export default {
		props: {
			show: {
				type: Boolean,
				default: false
      },
      // 已出函处申请发票时订单信息
			orderDetail: {
				type: Object,
				default: () => {}
      },
      // 待开票菜单重新申请时（批量）发票id集合
      orderRecoderIdArr: {
        type: Array,
        default: () => []
      },
      // 待开票模块是否批量申请
      isBatchOrder: {
        type: Boolean,
        default: false
      }
		},
		data() {
			return {
				page: 1,
				size: 15,
				totleListCount: 0,
				tableData: [],
				tableDec1: {
					invoiceTypeDec: 'el-icon-set-up',
					receiveEmail: 'el-icon-message',
					receiveAddr: 'el-icon-location-outline',
				},
				tableDec: {
					invoiceTitle: "发票抬头名称",
					invoiceCredit: "社会信用代码",
					companyAddr: "企业注册地址",
					baseBankName: "基本户开户银行",
					baseBankAccount: "基本户银行账号",
					companyCall: '公司电话'
				},
				choseRadio: -1,
				receiptTypeList: this.publicMethed.receiptType,
			}
		},
		created() {
			// console.log(this.orderDetail,'订单详情')
		},
		mounted() {
      this.requestInfo()
      console.log(this.orderDetail)
		},

		methods: {

			handleCurrentChange(val) {
				this.page = val
				this.requestInfo()
			},
			onChange(value) {
				this.choseRadio = value
			},
			requestInfo() {
				let data = {
					bidderId: this.userInfo.enterpriseId,
					page: this.page,
					size: this.size
				}
				this.requestAPI.queryInvoice(data).then((res) => {
					if (res.data == null || res.data.totalCount == 0) {
						this.$confirm('您还没有录入过发票信息, 是否前去录入?', '提示', {
							confirmButtonText: '确定',
							cancelButtonText: '取消',
							type: 'warning'
						}).then(() => {
							this.close()
							this.$router.push('/internalSystem/receipt/receipTitle')
						}).catch(() => {

						});
						return
					}
					let content = res.data.content
					content.sort((a, b) => {
						return Number(b.defaultFlag) - Number(a.defaultFlag)
					})
					content.forEach((item, index) => {
						if(item.defaultFlag == 1){
							this.choseRadio = index
						}
						item.invoiceTypeDec = this.receiptTypeList[item.invoiceType];
					})
					this.tableData = content
					
					this.totleListCount = res.data.totalCount
				})
			},
			close() {
				this.$emit("update:show", false)
			},
			submitBtn() {
				if (this.choseRadio == -1) {
					this.$message.error("请先选择发票抬头信息！")
					return
        }
        // 该判断是已出函菜单申请发票时发票在处理状态则不允许重复申请
				if (this.orderDetail.invoiceFlag == 1) {
					return
				}
				
				// if(this.tableData[this.choseRadio].invoiceType == 1 && this.orderDetail.bankNo == '35601'){
				// 	this.$confirm('应浙江稠州商业银行福州分行要求,申请增值税专用发票(纸质)时需提供《投标保函开具增值税发票申请表》是否下载申请表并提交发票申请?', '提示', {
				// 		confirmButtonText: '下载并提交申请',
				// 		cancelButtonText: '取消',
				// 		showCancelButton: false,
				// 		type: 'warning'
				// 	}).then(() => {
				// 		// 提交发票申请至后端
				// 		this.submitBtnFun()
				// 		// get请求下载文件
				// 		this.publicMethed.newDownFile('/document/download/invoiceApply?param='+this.tableData[this.choseRadio].invoiceId,{},'get','浙江稠州商业银行投标保函开具增值税发票申请表.docx')
						
				// 	}).catch(() => {});
				// }else{
					this.submitBtnFun()
				// }
				
			},

			// 申请开票
			submitBtnFun() {
                // 添加校验企业注册地址为空或者长度大于40
                let companyAddr = this.tableData[this.choseRadio].companyAddr;
                if(!companyAddr || companyAddr.length > 40){
                    let msg = !companyAddr ? "企业注册地址不能为空，请修改发票抬头中企业注册" : "开立发票，企业注册地址长度不得超过40位，请修改发票抬头中企业注册地址长度";
					this.$confirm( msg, '提示', {
						confirmButtonText: '确认',
						cancelButtonText: '取消',
						showCancelButton: false,
						showClose:false,
						type: 'warning'
					}).then(() => {
					})
					return 
                }
				// if(this.orderDetail.hasOwnProperty('recordId')){
        // 重新申请发票
				if(this.orderRecoderIdArr.length > 0){
					let data = {
						invoiceTitle: this.tableData[this.choseRadio].invoiceTitle,
						invoiceType: this.tableData[this.choseRadio].invoiceType,
						invoiceCredit: this.tableData[this.choseRadio].invoiceCredit,
						invoiceId: this.tableData[this.choseRadio].invoiceId,
						recordIds: this.orderRecoderIdArr,
						status:0
					}
					this.requestAPI.updateRecord(data).then((res) => {
            let type, message;
            let len = this.orderRecoderIdArr.length;
            let errLen = res.data.length;
            // 申请和失败条数一致，直接返回错误
            if(len === errLen){
              message = '该项目无法申请发票，如有疑问请联系客服人员';
              return this.$message.error(message)
            }else{
              if(errLen > 0){
                message = '有部分发票申请未能提交成功，请刷新页面后重新操作';
                type = 'warning';
              }else{
                message = '成功提交发票申请，请留意发票接收情况';
                type = 'success';
              }
            }
						this.$confirm(message, '提示', {
							confirmButtonText: '好的',
							cancelButtonText: '取消',
							showCancelButton: false,
							showClose:false,
              type,
              closeOnClickModal:false,
              closeOnPressEscape:false
						}).then(() => {
              this.close();
							this.$emit("successBack", res.data)
						}).catch(() => {});
					})
				}else{
          // 已出函首次申请发票
					let data = {
						invoiceApplyId: this.userInfo.enterpriseId,
						invoiceApplyType: this.userInfo.userType,
						invoiceTitle: this.tableData[this.choseRadio].invoiceTitle,
						invoiceType: this.tableData[this.choseRadio].invoiceType,
						invoiceCredit: this.tableData[this.choseRadio].invoiceCredit,
						orderApplicantId: this.orderDetail.applicantId,
						orderApplicantName: this.orderDetail.applicantName,
						orderTotalMoney: this.orderDetail.totalFee,
						invoiceMoneyTotal: this.orderDetail.totalFee,
						orderInvoiceMoney: this.orderDetail.totalFee,
						orderNo: this.orderDetail.orderNo,
						orderId: this.orderDetail.orderId,
						status: 0,
						invoiceId: this.tableData[this.choseRadio].invoiceId,
						guaranteeId: this.orderDetail.guaranteeId,
						guaranteeName: this.orderDetail.guaranteeName,
						sectionNo: this.orderDetail.sectionNo,
						sectionName: this.orderDetail.sectionName,
						submitDocumentsDeadline: this.orderDetail.submitDocumentsDeadline,
						amountGuaranteed: this.orderDetail.amountGuaranteed,
						validityBids: this.orderDetail.validityBids,
						bankAccoName: this.orderDetail.bankAccoName,
						issueTime: this.orderDetail.issueTime,
						bhno: this.orderDetail.bhNo,
						guaranteeBusiness: this.orderDetail.guaranteeBusiness,
						province:this.orderDetail.province,
						city:this.orderDetail.city,
						area:this.orderDetail.area
					}
					this.$set(this.orderDetail,'invoiceFlag',1)
					this.$set(this.orderDetail,'Status',0)
					this.requestAPI.applyInvoice(data).then((res) => {
						this.$confirm(res.errorMsg, '提示', {
							confirmButtonText: '好的',
							cancelButtonText: '取消',
							showCancelButton: false,
							showClose:false,
                            type: 'warning',
                            closeOnClickModal:false
						}).then(() => {
							this.close()
							this.$router.push("/internalSystem/receipt/receiptWait")
							this.$message({
								message: '操作成功!',
								type: 'success'
							});
						}).catch(() => {});
					}).catch(()=>{
						this.$set(this.orderDetail,'invoiceFlag', null)
						this.$set(this.orderDetail,'Status', null)
					})
				}
				
			}
		}
	}
</script>
<style>
	/* { */
	.innerBox::-webkit-scrollbar {
		/*滚动条整体样式*/

		width: 6px !important;
		/*高宽分别对应横竖滚动条的尺寸*/
		height: 6px !important;
		background: #ffffff !important;
		cursor: pointer !important;
	}

	/*滚动条里面小方块*/
	.innerBox::-webkit-scrollbar-thumb {
		border-radius: 5px !important;
		-webkit-box-shadow: inset 0 0 5px #ABABAB !important;
		background: #f1f1f1 !important;
		cursor: pointer !important;
	}

	/*滚动条里面轨道*/
	.innerBox::-webkit-scrollbar-track {
		/* -webkit-box-shadow: inset 0 0 5px #001529 !important; */
		border-radius: 0 !important;
		background: #f1f1f1 !important;
		cursor: pointer !important;
	}
</style>
<style lang="less" scoped>
	.applyInvoiceList {

		// /deep/ .el-dialog__wrapper{
		// 	    position: fixed;
		// 	    top: 50%;
		// 	    right: unset;
		// 	    bottom: unset;
		// 	    left: 50%;
		// 	    overflow: auto;
		// 	    margin: 0;
		// 	    transform: translate(-50%,-50%);
		// }
		// /deep/ .el-dialog{
		// 	margin: 0 !important;
		// }
		/deep/ .el-dialog__body {
			padding: 0;
			background-color: rgb(245, 245, 245);
		}

		/deep/ .el-dialog__header {
			line-height: 55px;
			padding: 0;
		}
		.innerBox {
			/deep/ .el-radio {
				margin-right: 0px;
				width: 100%;
			}

			/deep/ .el-radio__inner {
				border: 1px solid #1890FF;

			}

			/deep/ .is-disabled .el-radio__inner {
				border: 1px solid #E4E7ED;

			}

			height: 460px;
			overflow-y: scroll;
			padding: 15px 15px 0 15px;

			.innerContent {
				text-align: left;
				background-color: white;
				margin-bottom: 15px;
				padding: 12px 10px 10px 25px;
				border-radius: 4px;
				border: 1px solid #DDDDDD;
				position: relative;
				overflow: hidden;

				.defaltClass {
					background-color: #1890FF;
					color: white;
					width: 80px;
					height: 80px;
					line-height: 80px;
					text-align: center;
					position: absolute;
					right: -40px;
					top: -40px;
					transform: rotate(45deg);

					span {
						position: absolute;
						top: 25px;
						right: 25px;
						font-size: 15px;
					}
				}

				.innerContent1 {
					// letter-spacing: 1px;
					
					.nameClass {
						font-size: 16px;
						color: rgba(0, 0, 0, 0.85);
						line-height: 24px;
						font-weight: 600;
					}
				}

				.innerContent2 {
					color: rgba(0, 0, 0, 0.85);
					font-weight: 600;

					.inner2Index {
						margin-left: 7px;
						font-size: 12px;
						white-space: normal;
					}
				}

				.innerContent3 {
					display: flex;
					flex-wrap: wrap;

					.invoiceTitle {
						width: 33%;
						margin-top: 10px;
					}

					.valueDec {
						color: #808080;
						font-size: 12px;
						line-height: 25px;
					}

					.tableKeyDec {
						color: #333333;
						font-size: 12px;
						line-height: 18px;
						white-space: normal;
						margin-right: 2px;
					}
				}
			}
		}

		.sureSubmit {
			// height: 54px;
			// line-height: 54px;
			text-align: center;
			background-color: white;
      box-shadow: 0px -2px 1px #f5f5f5;
      box-sizing: border-box;
      margin-top: 4px;
      padding: 12px 0;
			.submitClass {
        display: inline-block;
				color: white;
				border-radius: 4px;
				height: 36px;
				line-height: 36px;
				background-color: #1890FF;
				font-size: 16px;
				padding: 0 12px;
				letter-spacing: 1px;
				cursor: pointer;
      }
      .tip{
        padding: 5px 0 0 15px;
        text-align: left;
        span{
          color: red;
          font-weight: 700;
        }
      }
		}
	}
</style>
